// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2xbQm","menuItems":"Menu_menuItems__1PeN0","itemsWrapper":"Menu_itemsWrapper__1VS5y"};